export default __webpack_public_path__ + "static/media/miguel-lopes-14.4b97fe56.jpg";